module.exports = __webpack_public_path__ + "static/media/control.da9bd383.svg";